export default __webpack_public_path__ + "static/media/me.52547454.png";